<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.goodsId" style="width: 110px;" size="mini" placeholder="商品id" clearable></el-input>
          <el-input v-model="formDatas.asId" style="width: 110px;" size="mini" placeholder="商户id" clearable></el-input>
          <el-input v-model="formDatas.stockId" style="width: 150px;" size="mini" placeholder="微信批次号" clearable></el-input>
          <el-select v-model="formDatas.wcsStatus" size="mini" clearable placeholder="本地状态" style="width: 130px;" @change="partserch">
            <el-option v-for="(name, key) in wcsStatusMap" :key="key" :label="name" :value="Number(key)"></el-option>
          </el-select>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="">搜索</el-button>
          <el-button type="success" size="mini" style="" @click="Out">导出</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="wcsId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getWxCouponStockList, startWxCouponStock, pauseWxCouponStock, restartWxCouponStock, getWxCouponStockCheck } from "../../api/api";
export default {
  name: "WxCouponStock",
  data() {
    return {
      wcsStatusMap: { 1: '已创建待激活', 2: '已激活', 3: '已暂停', 4: '已过期' },
      tableLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      cellStyleOption: {
        headerCellClass: ({ rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      formDatas: {
        goodsId: '',
        asId: '',
        stockId: '',
        wcsStatus: null,
        currentPage: 1,
        pageSize: 20
      },
      columns: [
        { field: "", key: "a", title: "序号", width: 50, align: "center", renderBodyCell: ({ rowIndex }, h) => { return ++rowIndex; } },
        { field: "goodsName", key: "goodsName", title: "商品", width: 170, align: "center", ellipsis: true },
        { field: "asName", key: "asName", title: "商户", width: 170, align: "center", ellipsis: true },
        { field: "subMchid", key: "subMchid", title: "子商户号", width: 110, align: "center" },
        { field: "stockId", key: "stockId", title: "微信批次号", width: 120, align: "center",
          renderBodyCell: ({ row }, h) => {
            return row.stockId ? <span>{row.stockId}</span> : <el-tag size="mini" type="danger">创建失败</el-tag>;
          } },
        { field: "couponAmount", key: "couponAmount", title: "面额/门槛(分)", width: 110, align: "center",
          renderBodyCell: ({ row }, h) => {
            return <span>{row.couponAmount}/{row.transactionMinimum}</span>;
          } },
        { field: "maxCoupons", key: "maxCoupons", title: "发放上限", width: 90, align: "center" },
        { field: "maxCouponsPerUser", key: "maxCouponsPerUser", title: "单用户限领", width: 90, align: "center" },
        { field: "availableBeginTime", key: "availableBeginTime", title: "可用时间", width: 220, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return <span>{(row.availableBeginTime || '').substring(0, 10)}~{(row.availableEndTime || '').substring(0, 10)}</span>;
          } },
        { field: "wcsStatus", key: "wcsStatus", title: "本地状态", width: 110, align: "center",
          renderBodyCell: ({ row }, h) => {
            const typeMap = { 1: 'warning', 2: 'success', 3: 'info', 4: 'danger' };
            return <el-tag size="mini" type={typeMap[row.wcsStatus] || 'info'}>{this.wcsStatusMap[row.wcsStatus]}</el-tag>;
          } },
        { field: "failReason", key: "failReason", title: "失败原因", width: 160, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return row.failReason ? <el-tooltip content={row.failReason} placement="top"><span style="color:#F56C6C">{row.failReason.substring(0, 30)}</span></el-tooltip> : <span>-</span>;
          } },
        { field: "createtime", key: "createtime", title: "创建时间", width: 150, align: "center" },
        { field: "", key: "d", title: "操作", width: 220, align: "center", fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            return (
              <div>
                {row.wcsStatus === 1 && row.stockId ? (
                  <el-button type="text" size="mini" on-click={() => this.startRow(row)}>激活</el-button>
                ) : null}
                {row.wcsStatus === 2 ? (
                  <el-button type="text" size="mini" on-click={() => this.pauseRow(row)}>暂停</el-button>
                ) : null}
                {row.wcsStatus === 3 ? (
                  <el-button type="text" size="mini" on-click={() => this.restartRow(row)}>重启</el-button>
                ) : null}
                <el-button type="text" size="mini" on-click={() => this.checkRow(row)}>同步状态</el-button>
              </div>
            );
          } },
      ],
    };
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = { ...this.formDatas };
      ['goodsId', 'asId', 'stockId'].forEach(k => { if (params[k] === '') delete params[k]; });
      getWxCouponStockList(params).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    startRow(row) {
      this.$confirm('确认激活批次？预充值模式激活时会从服务商营销账户锁定资金(面额×发放上限),请确认营销账户已充值。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.openLoading();
        startWxCouponStock({ wcsId: row.wcsId }).then((res) => {
          this.loadings.close();
          this.$message.success('激活成功');
          this.getList();
        }).catch(() => {
          this.loadings.close();
          this.getList();
        });
      });
    },
    pauseRow(row) {
      this.$confirm('确认暂停批次？暂停后用户无法再领取该批次券。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.openLoading();
        pauseWxCouponStock({ wcsId: row.wcsId }).then((res) => {
          this.loadings.close();
          this.$message.success('已暂停');
          this.getList();
        }).catch(() => {
          this.loadings.close();
        });
      });
    },
    restartRow(row) {
      this.$confirm('确认重启批次？', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.openLoading();
        restartWxCouponStock({ wcsId: row.wcsId }).then((res) => {
          this.loadings.close();
          this.$message.success('已重启');
          this.getList();
        }).catch(() => {
          this.loadings.close();
        });
      });
    },
    checkRow(row) {
      this.openLoading();
      getWxCouponStockCheck({ wcsId: row.wcsId }).then((res) => {
        this.loadings.close();
        this.getList();
      }).catch(() => {
        this.loadings.close();
      });
    },
    Out() {
      var s = qs.stringify({ wcsStatus: this.formDatas.wcsStatus });
      this.openLoading();
      var that = this;
      axios({
        method: 'post',
        url: config.baseURL + '/wx-coupon-stock/exportWxCouponStock',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then(res => {
        that.loadings.close();
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', objectUrl);
        a.setAttribute('download', '微信单品券批次.xlsx');
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(() => {
        that.loadings.close();
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
  },
};
</script>

<style scoped>
</style>
